module.exports = __webpack_public_path__ + "img/banner.e48fb66a.png";